exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".teka-container {\n  padding-bottom: 30px;\n}\n.teka-container iframe {\n    width: 100%;\n    height: calc(100vh - 200px);\n    border: 0;\n}\n", ""]);

// exports
